import { render, staticRenderFns } from "./UserManagementDropdown.vue?vue&type=template&id=47c13d04&scoped=true"
import script from "./UserManagementDropdown.vue?vue&type=script&lang=js"
export * from "./UserManagementDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c13d04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c13d04')) {
      api.createRecord('47c13d04', component.options)
    } else {
      api.reload('47c13d04', component.options)
    }
    module.hot.accept("./UserManagementDropdown.vue?vue&type=template&id=47c13d04&scoped=true", function () {
      api.rerender('47c13d04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/groups/UserManagementDropdown.vue"
export default component.exports